/*
  Sumário das páginas de política da Shopify.

  O HTML das políticas é gerado pela Shopify e o tema não pode
  editá-lo — então o sumário é montado aqui, a partir dos títulos
  que já existem no texto. Nenhum conteúdo muda: o sumário só
  repete os títulos e leva até eles.

  Quais títulos entram:
  - Se a política tem <h2> (a de Privacidade), só os <h2>.
  - Senão, os parágrafos que são uma frase inteira em negrito
    ("1. Direito de arrependimento — 7 dias"), menos o primeiro
    do texto, que repete o nome da própria política.
  - Numeração com um ponto (1.1) vira subitem recuado; com dois
    (1.2.1) fica de fora, para o sumário não ficar comprido.

  Sem títulos (Informações de contato) não há sumário e a página
  segue em uma coluna.
*/
(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  const nivel = (texto) => {
    const m = texto.match(/^(\d+(?:\.\d+)*)\.?\s/);
    return m ? m[1].split('.').length : 1;
  };

  const montar = () => {
    const container = document.querySelector('.shopify-policy__container');
    const corpo = container && container.querySelector('.shopify-policy__body');
    if (!corpo || container.querySelector('.pol-sumario')) return;

    let titulos = [...corpo.querySelectorAll('h2')];
    if (!titulos.length) {
      titulos = [...corpo.querySelectorAll('p')].filter((p) => {
        const filhos = [...p.childNodes].filter((n) => !(n.nodeType === 3 && !n.textContent.trim()));
        return filhos.length === 1 && filhos[0].nodeName === 'STRONG';
      });
      // o primeiro repete o nome da política
      const primeiroDoTexto = corpo.querySelector('p');
      if (titulos[0] && titulos[0] === primeiroDoTexto) titulos.shift();
    }
    const itens = titulos
      .map((el) => ({ el, texto: el.textContent.trim(), nivel: nivel(el.textContent.trim()) }))
      .filter((i) => i.texto && i.nivel <= 2);
    if (itens.length < 2) return;

    const nav = document.createElement('nav');
    nav.className = 'pol-sumario';
    nav.setAttribute('aria-label', 'Sumário');
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = 'Sumário';
    const lista = document.createElement('ol');

    itens.forEach((item, i) => {
      if (!item.el.id) item.el.id = `secao-${i + 1}`;
      item.el.classList.add('pol-ancora');
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${item.el.id}`;
      a.textContent = item.texto;
      if (item.nivel === 2) a.classList.add('pol-sumario__sub');
      a.addEventListener('click', () => { if (!DESKTOP.matches) details.open = false; });
      li.appendChild(a);
      lista.appendChild(li);
      item.link = a;
    });

    details.append(summary, lista);
    nav.appendChild(details);
    const titulo = container.querySelector('.shopify-policy__title');
    (titulo || corpo).after(nav);
    container.classList.add('tem-sumario');

    // Desktop: sempre aberto (o "Sumário" vira só o rótulo). Celular: recolhido.
    const ajustar = () => { details.open = DESKTOP.matches; };
    ajustar();
    DESKTOP.addEventListener('change', ajustar);

    // Destaca no sumário a seção que está sendo lida: a última cujo
    // título já passou da faixa de 160px abaixo do topo (o cabeçalho
    // grudado ocupa o começo da tela).
    let ativo = null;
    const atualizar = () => {
      let atual = itens[0];
      for (const item of itens) {
        if (item.el.getBoundingClientRect().top <= 160) atual = item; else break;
      }
      if (atual === ativo) return;
      if (ativo) ativo.link.removeAttribute('aria-current');
      ativo = atual;
      ativo.link.setAttribute('aria-current', 'true');
    };
    let agendado = false;
    window.addEventListener('scroll', () => {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(() => { agendado = false; atualizar(); });
    }, { passive: true });
    atualizar();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montar);
  else montar();
})();
